module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "16",
      "src": "images/top.jpg",
      "width": "500"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "18",
      "src": "images/bottom.jpg",
      "width": "500"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  })]), _c('p', {
    staticClass: "toc-front"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/foreword#foreword"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-front1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("EXCERPTS FROM")]), _c('br'), _vm._v("How to Stop Worrying and Start Living")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part01#part01"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART ONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "imagep"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "15",
      "src": "images/cbottom.jpg",
      "width": "500"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc-part1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part01#part01"
    }
  }, [_vm._v("Seven Ways to Peace and Happiness")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_vm._v("1 Find Yourself and Be Yourself: Remember, There Is No One Else on Earth like You")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02"
    }
  }, [_vm._v("2 Four Good Working Habits That Will Help Prevent Fatigue and Worry")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 What Makes You Tired—and What You Can Do About It")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 How to Banish the Boredom That Produces Fatigue, Worry, and Resentment")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Would You Take a Million Dollars for What You Have?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Remember That No One Ever Kicks a Dead Dog")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Do This—and Criticism Can’t Hurt You")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-front1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("EXCERPTS FROM")]), _c('br'), _vm._v("How to Win Friends and Influence People")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part02#part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART TWO")])])]), _vm._v(" "), _c('p', {
    staticClass: "imagep"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "15",
      "src": "images/cbottom.jpg",
      "width": "500"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc-part1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part02#part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fundamental Techniques in Handling People")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 “If You Want to Gather Honey, Don’t Kick Over the Beehive”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 The Big Secret of Dealing with People")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 “He Who Can Do This Has the Whole World with Him. He Who Cannot Walks a Lonely Way”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Do This and You’ll Be Welcome Anywhere")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 How to Make People Like You Instantly")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03#part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART THREE")])])]), _vm._v(" "), _c('p', {
    staticClass: "imagep"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "15",
      "src": "images/cbottom.jpg",
      "width": "500"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc-part1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03#part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ways to Win People to Your Way of Thinking")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 A Sure Way of Making Enemies—and How to Avoid It")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 The High Road to Reason")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 The Secret of Socrates")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 How to Get Cooperation")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 An Appeal That Everybody Likes")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part04#part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART FOUR")])])]), _vm._v(" "), _c('p', {
    staticClass: "imagep"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "15",
      "src": "images/cbottom.jpg",
      "width": "500"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc-part1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part04#part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ways to Change People Without Giving Offense or Arousing Resentment")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 How to Criticize—and Not Be Hated for It")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 Talk About Your Own Mistakes First")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 No One Likes to Take Orders")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 Let the Other Person Save Face In a Nutshell")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-back"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0